import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Environment } from 'src/environments/environment.model';

import { AbstractRepeatOrderDataSource } from './abstract-repeat-order.data-source';
import { RepeatOrderItemVM } from '../../../models/repeat-order-item.model';

export class BulkRepeatOrderDataSource extends AbstractRepeatOrderDataSource {
  constructor(store: Store, hasAtLeastAdvisorRole$: Observable<boolean>, env: Environment) {
    super(store, hasAtLeastAdvisorRole$, env);
  }

  protected selectSource(data: { bulk: RepeatOrderItemVM[]; generalCargo: RepeatOrderItemVM[] }): RepeatOrderItemVM[] {
    return data.bulk;
  }
}
